import { useCallback } from 'react';

interface ValidationResult {
  isValid: boolean;
  error: string | null;
}

export function validateUrl(url: string): ValidationResult {
  if (!url) {
    return { isValid: false, error: 'Please enter a URL' };
  }

  try {
    const parsedUrl = new URL(url);
    const isValidProtocol =
      parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';

    if (!isValidProtocol) {
      return {
        isValid: false,
        error: 'URL must start with http:// or https://',
      };
    }

    if (!parsedUrl.host) {
      return { isValid: false, error: 'Invalid URL format' };
    }

    return { isValid: true, error: null };
  } catch (err) {
    return { isValid: false, error: 'Please enter a valid URL' };
  }
}

export const useUrlValidation = () => {
  const validate = useCallback((url: string): ValidationResult => {
    return validateUrl(url);
  }, []);

  return { validateUrl: validate };
};
